<template>
  <div class="mb-1">
    <b-button variant="primary" @click="newGroup">
      Add New Time Frame
    </b-button>
    <b-row v-for="(g, ix) in groups" :key="ix" class="mt-1 time-frame__row">
      <b-col md="2" class="d-flex justify-content-center align-items-center">
        <h5>
          <strong>Time Frame #{{ ix + 1 }}</strong>
        </h5>
      </b-col>
      <b-col md="3">
        <b-form-group label="Start Time" :label-for="`start-time-${ix}`">
          <b-form-timepicker :id="`start-time-${ix}`" v-model="g.start_time" />
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group label="End Time" :label-for="`end-time-${ix}`">
          <b-form-timepicker :id="`end-time-${ix}`" v-model="g.end_time" />
        </b-form-group>
      </b-col>
      <b-col md="4" class="d-flex align-items-center justify-content-between">
        <b-button variant="danger" @click="removeFrame(ix)">
          <span>Remove Frame #{{ ix + 1 }}</span>
        </b-button>
      </b-col>
      <b-col md="12" class="my-1">
        <b-form-checkbox-group v-model="g.days" :options="daysOptions" />
      </b-col>
      <b-col md="12">
        <hr />
      </b-col>
      <b-col md="6">
        <Slicings
          slices-type="time"
          hide-fixed-slice
          :slicings="g.time_slicings"
          @time-slices="g.time_slicings = $event"
        />
      </b-col>
      <b-col md="6">
        <Slicings
          slices-type="distance"
          hide-fixed-slice
          :slicings="g.distance_slicings"
          @distance-slices="g.distance_slicings = $event"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { ref, watch } from "@vue/composition-api";
import {
  BRow,
  BCol,
  BButton,
  BFormTimepicker,
  BFormGroup,
  BFormCheckboxGroup,
} from "bootstrap-vue";
import Slicings from "./Slicings.vue";
// import { errorNotification } from '@/utils/toast-notifications'

export default {
  components: {
    BRow,
    Slicings,
    BCol,
    BButton,
    BFormGroup,
    BFormCheckboxGroup,
    BFormTimepicker,
  },
  props: {
    slices: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const daysOptions = [
      {
        text: "Sunday",
        value: 6,
      },
      {
        text: "Monday",
        value: 0,
      },
      {
        text: "Tueseday",
        value: 1,
      },
      {
        text: "Wednesday",
        value: 2,
      },
      {
        text: "Thursday",
        value: 3,
      },
      {
        text: "Friday",
        value: 4,
      },
      {
        text: "Saturday",
        value: 5,
      },
    ];
    const groups = ref(props.slices && props.slices.length ? props.slices : []);

    const newGroup = () => {
      groups.value.push({
        start_time: "09:00:00",
        end_time: "17:00:00",
        days: [],
        time_slicings: [],
        distance_slicings: [],
      });
    };

    watch(
      groups,
      () => {
        emit("time-frame-slices-set", groups.value);
      },
      { deep: true }
    );

    const removeFrame = (ix) => {
      groups.value.splice(ix, 1);
      emit("time-frame-slices-set", groups.value);
    };

    return {
      daysOptions,
      removeFrame,
      newGroup,
      groups,
    };
  },
};
</script>

<style scoped>
.time-frame__row {
  border: 2px dashed lightblue;
  border-radius: 12px;
  padding: 8px;
}
</style>
